<script lang="ts">
    import {Input, Kbd, Listgroup, ListgroupItem, Modal, Search} from "flowbite-svelte";
    import {shortcut} from '@svelte-put/shortcut';
    import {listEmployees} from "$lib/calls/employee";
    import {inlineShortcut} from "$lib/utils/inlineShortcut";
    import {goto} from "$app/navigation";
    import {get} from "$lib/api";
    import {onMount} from "svelte";
    import {page} from "$app/stores";


    let openSearch = false;
    let openID = false;
    let searchTerm = "";

    let searchResults = {};
    let timer;
    const debounce = (f: Function, delay = 500) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            f();
        }, delay);
    }

    const idSearch = async () => {
        const res = await get(`/employee?id=${searchTerm}`);
        if(res) {
            openID = false;
            searchTerm = '';
            await goto('/employee/' + res.uuid, {replaceState: true, invalidateAll: true})
        }
    }

    const handleShortcut = (event: CustomEvent) => {
        switch (event.detail.trigger.key) {
            case 's':
                openSearch = true;
                setTimeout(() => {
                    document.getElementById('global-searchbox').focus();
                })
                break;
            case 'f':
                openID = true;
                setTimeout(() => {
                    document.getElementById('id-search').focus();
                })
                break;
        }
    }


    let shortcuts = {
        trigger: [
            {key: 's', modifier: ['ctrl'], preventDefault: true}, // search
            {key: 'f', modifier: ['ctrl'], preventDefault: true},
        ]
    }


</script>
<svelte:window use:shortcut={shortcuts} on:shortcut={handleShortcut}/>
<Modal title="Mitarbeiter ID {$page.data?.employee?.id ? '(' +$page.data?.employee?.id + ')' : ''}" bind:open={openID} on:close={() => searchTerm = ''}>
    <form on:submit={idSearch}>
        <Input id="id-search" type="number" bind:value={searchTerm}/>
    </form>
</Modal>
<Modal title="Mitarbeiter Suche" bind:open={openSearch} on:close={() => searchTerm = ''}>
    <Search id="global-searchbox" bind:value={searchTerm}
            on:keydown={e => e.key === 'Alt' ? e.target.blur() : null}
            on:input={() => debounce(async () => searchResults = await listEmployees({search:searchTerm, page: 1, pageSize: 10}))}
            placeholder="Mitarbeiter"/>
    {#if searchResults?.collection?.length > 0}
        <Listgroup active>
            {#each searchResults.collection as item,i}
                <ListgroupItem >
                    <a class="flex-1" href="/employee/{item.uuid}" on:click={() => openSearch = false} use:inlineShortcut={{alt: true, code: 'Digit'+(i+1), callback: ()=> {
                       goto('/employee/'+item.uuid, {replaceState: true, invalidateAll: true})
                       openSearch = false
                    }}}><Kbd class="px-2 py-1.5">Alt</Kbd> + <Kbd class="px-2 py-1.5">{i+1}</Kbd> {item.name}</a>
                </ListgroupItem>

            {/each}
        </Listgroup>
    {/if}
</Modal>
